// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fordMetrics_wrapper__16OIB","table":"fordMetrics_table__3Gycr","tableHeader":"fordMetrics_tableHeader__21kHf","tableBody":"fordMetrics_tableBody__3T6qY"};